import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import GeneralModal from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.generalModal,
  };
}

export default withRouter(connect(mapStateToProps)(GeneralModal));



// WEBPACK FOOTER //
// ./src/components/GeneralModal/container/index.js